module.exports = __webpack_public_path__ + "static/item--chloe--f2@3x.c77caf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f2@3x.png
// module id = 636
// module chunks = 126511778744290